import {
  AMCPerformanceProductsReq,
  AMCPerformanceProductsRes,
  AMC_PERFORMANCE_DOWNLOAD,
  AMC_PERFORMANCE_DOWNLOAD_SUCCESS,
  ASSET_CLASS_DETAILS,
  ASSET_CLASS_DETAILS_SUCCESS,
  AmcPerformanceDownloadReq,
  AssetClassDetailsReq,
  AssetClassDetailsRes,
  BENCHMARK_PERFORMANCE,
  BENCHMARK_PERFORMANCE_SUCCESS,
  BenchmarkPerformanceReq,
  BenchmarkPerformanceRes,
  CREDIT_RATING,
  CREDIT_RATING_SUCCESS,
  CategoryWiseDistibutionRes,
  CategoryWiseDistributionReq,
  CreditRatingReq,
  CreditRatingRes,
  FILTERS_TYPE,
  GET_AMC_PRODUCTS_PERFORMANCE,
  GET_AMC_PRODUCTS_PERFORMANCE_SUCCESS,
  GET_CATEGORY_DISTRIBUTION,
  GET_CATEGORY_DISTRIBUTION_SUCCESS,
  GET_FUND_HOUSE_PERFORMANCE,
  GET_FUND_HOUSE_PERFORMANCE_SUCCESS,
  GET_HOLDING_DETAILS_FILTER,
  GET_HOLDING_DETAILS_FILTER_SUCCESS,
  GET_ISSUER_CATEGORY,
  GET_ISSUER_CATEGORY_SUCCESS,
  GET_NON_MF_TRANSACTION_DETAILS,
  GET_NON_MF_TRANSACTION_DETAILS_SUCCESS,
  GET_QUANTITATIVE_ANALYSIS,
  GET_QUANTITATIVE_ANALYSIS_SUCCESS,
  GET_SCHEME_DETAILS,
  GET_SCHEME_DETAILS_SUCCESS,
  GET_SEBI_ASSET_ALLOCATION,
  GET_SEBI_ASSET_ALLOCATION_SUCCESS,
  GET_TOP_10_SCHEMES,
  GET_TOP_10_SCHEMES_SUCCESS,
  GET_TRANSACTION_DETAILS,
  GET_TRANSACTION_DETAILS_SUCCESS,
  GetFundHousePerformanceRequestData,
  GetFundHousePerformanceResponseData,
  GetHoldingDetailsFilterResponseBody,
  GetQuantitativeAnalysisRequestBody,
  GetQuantitativeAnalysisResponseBody,
  GetSchemeDetailsRequestBody,
  GetSchemeDetailsResponseBody,
  GetTop10SchemesReq,
  GetTop10SchemesRes,
  GetTransactionDetailsRequestBody,
  GetTransactionDetailsResponseBody,
  INSURANCE_COMPANY_OVERVIEW,
  INSURANCE_COMPANY_OVERVIEW_SUCCESS,
  INSURANCE_COMPANY_TURNOVER,
  INSURANCE_COMPANY_TURNOVER_SUCCESS,
  INSURANCE_POLICY_DETAILS,
  INSURANCE_POLICY_DETAILS_SUCCESS,
  INSURANCE_PREMIUM_SCHEDULE,
  INSURANCE_PREMIUM_SCHEDULE_SUCCESS,
  InsuranceCompanyOverviewReq,
  InsuranceCompanyOverviewRes,
  InsuranceCompanyTurnoverReq,
  InsuranceCompanyTurnoverRes,
  InsurancePolicyDetailsReq,
  InsurancePolicyDetailsRes,
  InsurancePremiumScheduleReq,
  InsurancePremiumScheduleRes,
  IssuerCategoryReq,
  IssuerCategoryRes,
  MARKET_CAP_ALLOCATION,
  MARKET_CAP_ALLOCATION_SUCCESS,
  MarketCapAllocationReq,
  MarketCapAllocationRes,
  PERFORMANCE_NAV_CHART,
  PERFORMANCE_NAV_CHART_SUCCESS,
  PORTFOLIO_EXPOSURE_MF,
  PORTFOLIO_EXPOSURE_MF_SUCCESS,
  PerformanceNavChartRes,
  PortfolioExposureMFReq,
  PortfolioExposureMFRes,
  RATING_AND_MATURITY,
  RATING_AND_MATURITY_SUCCESS,
  RatingAndMaturityReq,
  RatingAndMaturityRes,
  SECTOR_ALLOCATION,
  SECTOR_ALLOCATION_SUCCESS,
  SET_FILTERS,
  SebiAssetAllocationReq,
  SebiAssetAllocationRes,
  SectorAllocationRequestData,
  SectorAllocationResponseData,
  TOTAL_CARD_VALUES,
  TOTAL_CARD_VALUES_SUCCESS,
  TotalCardValuesReq,
  TotalCardValuesRes,
  getNonMfTranDetailsReqBody,
  getNonMfTranDetailsResBody,
  performanceNavChartReq,
} from '../types/products';
import { CALL_API } from "../middleware"
import { encodeBase64 } from '../../utils/utilityFunctions';
import { CONTENT_TYPE } from '../../utils/constant';

export const setFilters = (filters: FILTERS_TYPE): { type: string; filters: FILTERS_TYPE } => {
  return {
    type: SET_FILTERS,
    filters,
  };
};

export const getCategoryWiseDistribution =
  (body: CategoryWiseDistributionReq) =>
    async (dispatch: any): Promise<CategoryWiseDistibutionRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/categoryWiseDistribution`,
          method: 'POST',
          types: [GET_CATEGORY_DISTRIBUTION_SUCCESS, GET_CATEGORY_DISTRIBUTION],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getSebiAssetAllocation =
  (body: SebiAssetAllocationReq) =>
    async (dispatch: any): Promise<SebiAssetAllocationRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/sebiAssetAllocation`,
          method: 'POST',
          types: [GET_SEBI_ASSET_ALLOCATION_SUCCESS, GET_SEBI_ASSET_ALLOCATION],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };


export const getProductsAMCPerformance =
  (body: AMCPerformanceProductsReq) =>
    async (dispatch: any): Promise<AMCPerformanceProductsRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/amcPerformanceAnalysis`,
          method: 'POST',
          types: [GET_AMC_PRODUCTS_PERFORMANCE_SUCCESS, GET_AMC_PRODUCTS_PERFORMANCE],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getSchemeDetails =
  (body: GetSchemeDetailsRequestBody) =>
    async (dispatch: any): Promise<GetSchemeDetailsResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/schemeDetails`,
          method: 'POST',
          types: [GET_SCHEME_DETAILS_SUCCESS, GET_SCHEME_DETAILS],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const top10Schemes =
  (body: GetTop10SchemesReq) =>
    async (dispatch: any): Promise<GetTop10SchemesRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/topSchemes`,
          method: 'POST',
          types: [GET_TOP_10_SCHEMES_SUCCESS, GET_TOP_10_SCHEMES],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const totalCardValuesApi =
  (body: TotalCardValuesReq) =>
    async (dispatch: any): Promise<TotalCardValuesRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/totalValues`,
          method: 'POST',
          types: [TOTAL_CARD_VALUES_SUCCESS, TOTAL_CARD_VALUES],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };
export const portfolioExposureInCategory =
  (body: PortfolioExposureMFReq) =>
    async (dispatch: any): Promise<PortfolioExposureMFRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/portfolioExposure`,
          method: 'POST',
          types: [PORTFOLIO_EXPOSURE_MF_SUCCESS, PORTFOLIO_EXPOSURE_MF],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getMarketCapAllocation =
  (body: MarketCapAllocationReq) =>
    async (dispatch: any): Promise<MarketCapAllocationRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/marketCapAllocation`,
          method: 'POST',
          types: [MARKET_CAP_ALLOCATION_SUCCESS, MARKET_CAP_ALLOCATION],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getSectorAllocation =
  (body: SectorAllocationRequestData) =>
    async (dispatch: any): Promise<SectorAllocationResponseData> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/sectorAllocation`,
          method: 'POST',
          types: [SECTOR_ALLOCATION_SUCCESS, SECTOR_ALLOCATION],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getRatingAndMaturity =
  (body: RatingAndMaturityReq) =>
    async (dispatch: any): Promise<RatingAndMaturityRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/ratingAndMaturity`,
          method: 'POST',
          types: [RATING_AND_MATURITY_SUCCESS, RATING_AND_MATURITY],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getIssuerCategoryAllocation =
  (body: IssuerCategoryReq) =>
    async (dispatch: any): Promise<IssuerCategoryRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/issuerAndInstrumental`,
          method: 'POST',
          types: [GET_ISSUER_CATEGORY_SUCCESS, GET_ISSUER_CATEGORY],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getQuantitativeAnalysis =
  (body: GetQuantitativeAnalysisRequestBody) =>
    async (dispatch: any): Promise<GetQuantitativeAnalysisResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/quantitativeForEquityAndHybrid`,
          method: 'POST',
          types: [GET_QUANTITATIVE_ANALYSIS_SUCCESS, GET_QUANTITATIVE_ANALYSIS],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const performanceNavChart =
  (body: performanceNavChartReq) =>
    async (dispatch: any): Promise<PerformanceNavChartRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/investorPerformance`,
          method: 'POST',
          types: [PERFORMANCE_NAV_CHART_SUCCESS, PERFORMANCE_NAV_CHART],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getTransactionDetails =
  (body: GetTransactionDetailsRequestBody) =>
    async (dispatch: any): Promise<GetTransactionDetailsResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/transactions/getTransactionDetailsByRm',
          method: 'POST',
          types: [GET_TRANSACTION_DETAILS_SUCCESS, GET_TRANSACTION_DETAILS],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getNonMfTransactionDetails =
  (body: getNonMfTranDetailsReqBody) =>
    async (dispatch: any): Promise<getNonMfTranDetailsResBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/transactions/getNonMfTransactionDetailsByRm',
          method: 'POST',
          types: [GET_NON_MF_TRANSACTION_DETAILS_SUCCESS, GET_NON_MF_TRANSACTION_DETAILS],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    }

export const amcPerformanceDownload =
  (body: AmcPerformanceDownloadReq) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/reports/exportTable',
          method: 'POST',
          types: [AMC_PERFORMANCE_DOWNLOAD_SUCCESS, AMC_PERFORMANCE_DOWNLOAD],
          body,
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };

export const getFundHousePerformance =
  (body: GetFundHousePerformanceRequestData) =>
    async (dispatch: any): Promise<GetFundHousePerformanceResponseData> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/dashboard/fundHousePerformance',
          method: 'POST',
          types: [GET_FUND_HOUSE_PERFORMANCE_SUCCESS, GET_FUND_HOUSE_PERFORMANCE],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getHoldingDetailsFilter =
  () => async (dispatch: any): Promise<GetHoldingDetailsFilterResponseBody> => {
    return await dispatch({
      [CALL_API]: {
        url: '/onboarding/dashboard/getHoldingDetailsFilter',
        method: 'GET',
        types: [GET_HOLDING_DETAILS_FILTER_SUCCESS, GET_HOLDING_DETAILS_FILTER],
      },
    });
  };

export const getCreditRatingExposure =
  (body: CreditRatingReq) =>
    async (dispatch: any): Promise<CreditRatingRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/creditRatingExposure`,
          method: 'POST',
          types: [CREDIT_RATING_SUCCESS, CREDIT_RATING],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };


export const getBenchmarkPerformance =
  (body: BenchmarkPerformanceReq) =>
    async (dispatch: any): Promise<BenchmarkPerformanceRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/benchmarkPerformance`,
          method: 'POST',
          types: [BENCHMARK_PERFORMANCE_SUCCESS, BENCHMARK_PERFORMANCE],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getAssetClassDetails =
  (body: AssetClassDetailsReq) =>
    async (dispatch: any): Promise<AssetClassDetailsRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/get-products-performance`,
          method: 'POST',
          types: [ASSET_CLASS_DETAILS_SUCCESS, ASSET_CLASS_DETAILS],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };


export const getInsuranceCompanyTurnover = 
  (body: InsuranceCompanyTurnoverReq) =>
    async (dispatch: any): Promise<InsuranceCompanyTurnoverRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/companyTurnover`,
          method: 'POST',
          types: [INSURANCE_COMPANY_TURNOVER_SUCCESS, INSURANCE_COMPANY_TURNOVER],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getInsuranceCompanyOverview =
  (body: InsuranceCompanyOverviewReq) =>
    async (dispatch: any): Promise<InsuranceCompanyOverviewRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/insuranceCompanyOverview`,
          method: 'POST',
          types: [INSURANCE_COMPANY_OVERVIEW_SUCCESS, INSURANCE_COMPANY_OVERVIEW],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getInsurancePremiumSchedule = 
  (body: InsurancePremiumScheduleReq) =>
    async (dispatch: any): Promise<InsurancePremiumScheduleRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/premiumSchedule`,
          method: 'POST',
          types: [INSURANCE_PREMIUM_SCHEDULE_SUCCESS, INSURANCE_PREMIUM_SCHEDULE],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

  export const getInsurancePolicyDetails = 
  (body: InsurancePolicyDetailsReq) =>
    async (dispatch: any): Promise<InsurancePolicyDetailsRes> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/dashboard/policyDetails`,
          method: 'POST',
          types: [INSURANCE_POLICY_DETAILS_SUCCESS, INSURANCE_POLICY_DETAILS],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
        },
      });
    };